"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatercolorBrushShader = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const BrushShader_1 = require("./BrushShader");
const watercolor_frag_1 = __importDefault(require("./glsl/watercolor.frag"));
class WatercolorBrushShader extends BrushShader_1.BrushShader {
    constructor() {
        super(watercolor_frag_1.default, {});
        this.ticker.speed = 1 / 60;
    }
}
exports.WatercolorBrushShader = WatercolorBrushShader;
